import { Collection } from 'core/model/Collection';
import { action, observable } from 'mobx';
import { Model } from 'core/model/Model';
import { InferModelType } from 'core/model/model.types';

/**
 * This represents a "View" belonging to a Collection, allowing us to expose a subset of Collection data without modifying
 * the parent Collection at all.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ViewCollection<MOD extends Model<any>> extends Collection<MOD> {
  @observable.ref
  private readonly parentCollection: Collection<MOD>;

  /**
   * @param data generally this should be filtered data, though you might alternatively perform filtering after instantiation.
   * @param parentCollection
   * @param options options for creating the Collection.
   */
  constructor(data: MOD[] | InferModelType<MOD>[], parentCollection: Collection<MOD>, options = {}) {
    super(data, options);
    this.parentCollection = parentCollection;
  }

  /**
   * This is the main reason this class exists in the first place - we need to propagate changes in the View back into the parent.
   */
  @action
  public remove = (ids: string | string[], destroyModels?: boolean) => {
    this.parentCollection.remove(ids, destroyModels);
  };

  public get url() {
    console.error('Illegal attempt to fetch from a ViewCollection');
    return '';
  }

  public get model() {
    return this.parentCollection?.model;
  }
}
